<template>
  <div class="row row-spacing">
    <div class="col-md-12">
      <div
        class="table-responsive table-bordered"
        v-if="searchResults.length > 0"
      >
        <table class="table table-hover">
          <thead>
            <tr class="text-nowrap">
              <th>Type</th>
              <th>Matched</th>
              <th>Quick Info</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(searchResult, index) in searchResults"
              :key="index"
              :class="{
                'search-result-error': Object.keys(
                  searchResult.metaData
                ).includes('Error'),
                'unsearchable': noSearch(searchResult.type)
              }"
            >
              <td class="text-nowrap" @click="viewResult(searchResult)">
                <i :class="getTypeIcon(searchResult.type)"></i
                ><span> {{ getSearchLabel(searchResult) }}</span>
              </td>
              <td @click="viewResult(searchResult)">{{ searchResult.result }}</td>
              <td @click="viewResult(searchResult)">
                <div
                  v-for="metaKey in Object.keys(searchResult.metaData).filter(
                    (metaKey) => !metaKey.includes('_')
                  )"
                  :key="metaKey"
                >
                  <small
                    ><b>{{ metaKey }}:</b>
                    {{ searchResult.metaData[metaKey] }}</small
                  >
                </div>
              </td>
              <td class="text-center">
                <button               
                  v-tooltip="'New Tab'"
                  type="button"
                  class="btn btn-sm btn-primary m-1"
                  @click="openResult(searchResult)"
                >
                  <em class="fa-regular fa-window-restore"></em>
                </button>
                <div class="dropdown" v-if="availableTypes(searchResult.type)">
                  <a
                    href="#"
                    v-tooltip="'Options'"
                    class="btn btn-info"
                    data-toggle="dropdown"
                    role="button"
                    id="dropdownMenuLink"
                    @click="toggleDropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </a>
                  <div class="dropdown-menu">
                    <a
                      class="dropdown-item text-dark"
                      @click="goTo(option, searchResult)"
                      v-for="option in options[searchResult.type.toLowerCase()]"
                      :key="option.name"
                      >{{ option.name }}</a
                    >
                  </div>
                </div>
                <a
                  v-if="searchResult.type == 'Sale'"
                  href="javascript:void(0)"
                  @click="goTo('clientdetail', searchResult)"
                  >{{ searchResult.metaData.Client }}</a
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>No Results...</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    searchResults: {
      type: Array,
      required: true,
    },
  },
  computed: {
    noSearch: () => (i) => {
      switch (i) {
        case "Vendor":
        case "BankStatementLine":
        case "CreditNoteDetail":
        case "CustomFieldValue":
          return true;
        default:
          return false;
      }
    },
    getTypeIcon: () => (type) => {
      switch (type) {
        case "Sale":
          return "fa fa-money";
        case "SaleArchive":
          return "fa-solid fa-box-archive"
        case "Client":
        case "Reseller":
          return "fa fa fa-building-o";
        case "Supplier":
          return "fa-solid fa-parachute-box"
        case "Person":
        case "ClientUser":
        case "ResellerUser":
        case "LiquidCustomer":
          return "fa fa-user";
        case "StaffUser":
          return "fa fa-user-secret";
        case "Product":
          return "fa fa-product-hunt";
        case "Document":
        case "DocumentLine":
        case "WorkOrder":
          return "fa fa-briefcase";
        case "Host":
          return "fa-solid fa-cloud";
        case "LabourEntry":
        case "EquipmentEntry":
        case "SoftwareEntry":
        case "TravelEntry":
          return "fa-solid fa-pencil"
        case "Domain":
        case "PublicIpv4ReverseZone":
        case "PublicIpv6ReverseZone":
        case "PublicIpv4ReverseRecord":
        case "PublicIpv6ReverseRecord":
          return "fa-solid fa-globe";
        default:
          return "fa fa-search";
      }
    },
    getSearchLabel: () => (result) => {
      if (result) {
        const product = result?.metaData?.Product;
        const type = result?.type;
        const label = result?.label;

        if (product && type === "Sale") return product;
        else return label;
      }
    },
  },
  data() {
    return {
      options: {
        client: [
          {
            name: "Client",
            routeName: "clientdetail",
          },
          {
            name: "Services",
            routeName: "clientsales",
          },
          {
            name: "Invoices",
            routeName: "clientdocuments",
          },
          {
            name: "Statement",
            routeName: "clientstatement",
          },
          {
            name: "Correspondence",
            routeName: "clientcorrespondence",
          },
          {
            name: "Workorders",
            routeName: "clientworkorders",
          },
        ],
      },
    };
  },
  methods: {
    availableTypes(type) {
      type = type.toLowerCase();
      if (this.options[type]) {
        return true;
      } else {
        return false;
      }
    },
    goTo(option, result) {
      switch (result.type) {
        case "Client":
          this.$router.push({
            name: option.routeName,
            params: {
              clientNumber: result.key,
            },
          });
          break;
        case "Sale":
          this.$router.push({
            name: option,
            params: {
              clientNumber: result.metaData._clientNumber,
            },
          });
          break;
        default:
          this.showWarning(result.type + " type is not available yet.");
          break;
      }
    },
    toggleDropdown(e) {
      $(e.target).dropdown("toggle");
      e.preventDefault();
      e.stopPropagation();
    },
    viewResult(result) {
      if (Object.keys(result.metaData).includes("Error")) {
        this.showWarning(
          "An error occurred while loading this search result",
          result.metaData.Error
        );
        return;
      }
      this.$emit("search-item-clicked", result);
    },
    openResult(result) {
      if (Object.keys(result.metaData).includes("Error")) {
        this.showWarning(
          "An error occurred while loading this search result",
          result.metaData.Error
        );
        return;
      }
      this.$emit("open-new-tab", result);
    }
  },
};
</script>

<style>
.unsearchable,.unsearchable:hover {
    cursor: default !important;
    background-color: #F5F5F5;
    pointer-events: none; 
}
</style>
